// src/portals/creator/components/CreatorNavLinks.js
import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  PenSquare,
  DollarSign,
  Send,
  BarChart2,
  Folder,
  Wallet,
  Users,
  Settings,
} from "lucide-react";

const navLinks = [
  { name: "Dashboard", href: "/dashboard", icon: LayoutDashboard },
  { name: "Content Hub", href: "/dashboard/content", icon: Folder },
  { name: "Monetization", href: "/dashboard/monetization", icon: DollarSign },
  { name: "Engagement", href: "/dashboard/engagement", icon: Send },
  { name: "Adnakian", href: "/dashboard/audience", icon: Users },
  { name: "Analytics", href: "/dashboard/analytics", icon: BarChart2 },
  { name: "Wallet", href: "/dashboard/wallet", icon: Wallet },
  { name: "Media Library", href: "/dashboard/media", icon: Folder },
  { name: "Settings", href: "/dashboard/settings", icon: Settings },
];

const getNavLinkClasses = (isActive, textClassName) => {
  const baseClasses =
    "flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors";
  if (isActive) {
    return `${baseClasses} bg-primary text-white`;
  }
  return `${baseClasses} ${textClassName} hover:bg-primary/10 hover:text-primary`;
};

const CreatorNavLinks = ({ isCollapsed, textClassName = "text-slate-600" }) => {
  return (
    <nav className="space-y-2">
      {navLinks.map((link) => (
        <NavLink
          key={link.name}
          to={link.href}
          end={link.href === "/dashboard"}
          className={({ isActive }) =>
            getNavLinkClasses(isActive, textClassName)
          }
          title={isCollapsed ? link.name : undefined}
        >
          <link.icon
            className={`w-5 h-5 flex-shrink-0 ${isCollapsed ? "" : "mr-3"}`}
          />
          {!isCollapsed && (
            <span className="whitespace-nowrap">{link.name}</span>
          )}
        </NavLink>
      ))}
    </nav>
  );
};

export default CreatorNavLinks;
